import {
  type DataServiceResponse,
  type DataServiceError,
  HttpService,
} from "@p2l/data-service";
import { getApi, getCulture, getPrincipal, getToken } from "@p2l/config";

export const challengeAuthentication = (returnUrl?: string) => {
  if (returnUrl == undefined) {
    returnUrl = window.location.href;
  }
  window.location.assign(
    `${
      window.location.origin
    }/frontend-shell/authenticate?returnUrl=${encodeURIComponent(returnUrl)}`
  );
};

const defaultConfiguration = {
  useCorelationId: true,
  onSuccess: (response: DataServiceResponse<any>) => Promise.resolve(response),
  onError: <T>(error: DataServiceError<T>) => {
    if (error.response!.status === 401) {
      var resolved = Promise.resolve(error);
      if (!getPrincipal().id) {
        challengeAuthentication();
      }
      return resolved;
    }
    return Promise.reject(error);
  },
};

// Dependant services
export const frontpageHttpService = new HttpService({
  baseUrl: "",
  ...defaultConfiguration,
});

export const guideHttpService = new HttpService({
  baseUrl: "",
  ...defaultConfiguration,
});

const setAdditionalHeaders = (service: HttpService) => {
  service.setAuthorizationHeader(getToken());
  service.setHeaderValue(getCulture(), "Accept-Language");
  service.setHeaderValue("no-cache", "Pragma");
};

export const configureHttp = () => {
  //@ts-ignore
  frontpageHttpService.setBaseUrl(getApi("frontpage"));
  guideHttpService.setBaseUrl(getApi("guide"));

  setAdditionalHeaders(frontpageHttpService);
  setAdditionalHeaders(guideHttpService);
};
